import style from "./style.scss";
import { mergeClasses } from "../helpers";

const NoWrap = ({ children, class: className = null }) => (
  <span class={mergeClasses([style.noWrap, className])}>{children}</span>
);

export default NoWrap;
